

/**
 *
 * Helper to preload images
 *
 * @param {object} $img - jquery image object to load as jquery selection
 * @param {function} callback - function to call after image loading
 * @return void
 */
var preload = function($img, callback) {
  var image_to_load, complete;

  // Create dummy image to ensure
  // proper reading of 'complete' property
  image_to_load = $('<img>');

  // Assign load handler
  image_to_load.one('load', function() {
    callback.apply(callback, [$img]);
    return true;
  });

  // Set src of dummy image
  image_to_load.attr('src', $img.attr('src'));

  // Get complete property
  complete = image_to_load[0].complete;

  if (complete === false) {
    return;
  }

  if (complete === true) {
    image_to_load.trigger('load');
    return;
  }

  image_to_load.trigger('load');
};

/**
 *
 * Sets padding on image wrapper depending on
 * current breakpoint. This is done to ensure that layout remains
 * unchanged as the image-src is dynamically inserted
 *
 * @param {object} $img - jquery selected image
 * @return void
 */
function setImagePadding($img, currentBreakPoint) {
  var dimensions = $img.data('dimensions'),
    paddingTop;

  if (dimensions && dimensions[currentBreakPoint]) {
    paddingTop = dimensions[currentBreakPoint];
  } else if(dimensions) {
    paddingTop = dimensions['large'];
  }

  if (paddingTop) {
    $img.parent('.js-imgparent').css('padding-top', paddingTop);
  }
}


export {preload, setImagePadding};



// WEBPACK FOOTER //
// ./src/js/plugins/img-utils.js